import React from 'react';
import { ReviewCard } from '../../components/ReviewCard';
import { STORM_REVIEWS } from '../../components/realReviews';
export function StartFreeReviews() {
  return <section className="py-24 bg-off-white" data-id="element-3102">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-3103">
        <h2 className="text-4xl text-ink text-center mb-16" data-id="element-3104">
          Real Parent Reviews
        </h2>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-3105">
          {STORM_REVIEWS.slice(0, 6).map(review => <ReviewCard key={review.name} quote={review.quote} name={review.name} label={review.label} data-id="element-3106" />)}
        </div>
        <p className="text-center text-sm text-gray-warm mt-8" data-id="element-3107">
          ★★★★★ 5.0 Rating From 201 Reviews
        </p>
      </div>
    </section>;
}